var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadertestTentacles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M17.778 28.318v-24.635c6.023 0.864 10.667 6.059 10.667 12.316 0 6.26-4.644 11.452-10.667 12.318zM17.778 0.105v-0.105h-3.556v0.105c-7.988 0.889-14.222 7.675-14.222 15.895s6.235 15.008 14.222 15.895v0.105h3.556v-0.105c7.988-0.887 14.222-7.675 14.222-15.895s-6.235-15.006-14.222-15.895z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadertestTentacles);
export default __webpack_public_path__ + "static/media/headertest-tentacles.2a5e49b0278d670b1d77e28b0bebbe1c.svg";
export { ForwardRef as ReactComponent };